import React from "react";
import { connect } from "react-redux";
import {
  Button,
  Heading,
  InlineAlert,
  Pane,
  Small,
  Strong,
  Switch,
  Text,
  TextInput,
  TextInputField,
  toaster,
  CalendarIcon,
  TimeIcon,
  Menu,
  majorScale,
  MinusIcon,
  PlusIcon,
} from "evergreen-ui";

import {
  confirmBooking,
  getCountryCodes,
  getCustomerDetails,
  updateCartData,
} from "../external/actions";
import CountryCodeSelector from "../components/countryCodeSelector";
import CourtSelector from "../components/courtSelector";
import {
  clearCart,
  getCartDetails,
  getCartSummaryAndPrice,
  getCookie,
  getCurrency,
  getFormattedDate,
  getFormattedTime,
  getCommonCourts,
  getCartPrice,
} from "../util";
import Loader from "../components/loader";
import ConfirmationDialog from "../components/confirmationDialog";
import BookingConfirmationDialogContent from "../components/bookingConfirmationDialogContent";
import validator from "validator";
import EditAmountDialog from "../components/editAmountDialog";
import BackBar from "../components/backBar";

class Checkout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isRedeemCredits: false,
      selectedCountryCode: "",
      memberPin: "",
      customerMobile: "",
      customerName: "",
      customerEmail: "",
      paidStatus: false,
      disableNameAndEmailEdit: false,
      selectedCourt: {
        courtId: "",
      },
      maxBookable: 0,
      count: 1,
      loader: false,
      confirmationDialog: {
        isShown: false,
        header: "",
        confirmLabel: "",
        cancelLabel: "",
        intent: "none",
        information: "",
        action: null,
        closeAction: null,
      },
      invalidCustomerMobile: false,
      invalidCustomerName: false,
      invalidMemberPin: false,
      editAmountDialogIsShown: false,
      sendPaymentLink: false,
      sendBookingConfirmationSMS: false,
      invalidEmail: false,
      activityType: "",
    };
    this.baseState = this.state;
  }

  async componentDidMount() {
    if (!getCookie("authToken")) {
      this.props.history.push("/login");
    }
    const cartDetails = getCartDetails();

    if (!(cartDetails.slots && cartDetails.slots.length)) {
      this.props.history.push("/");
    } else {
      const activityType = localStorage.getItem("activityType") || "0";

      this.setState({
        activityType: parseInt(activityType),
      });
      if (parseInt(activityType) === 1) {
        await cartDetails.slots.map((slot) => {
          slot.slot.activityType = parseInt(activityType);
          slot.slot.count = 1;
        });
      }

      await this.props.dispatch(updateCartData(cartDetails));
      await this.props.dispatch(getCountryCodes());
    }
    await this.setState({
      selectedCountryCode: getCookie("countryCode"),
    });
  }

  back = async () => {
    this.setState({
      ...this.baseState,
    });
    this.props.dispatch({ type: "SET_BOOKING_DATA", data: null });
    this.props.dispatch({ type: "SET_CUSTOMER_DATA", data: null });
    this.props.history.push("/");
  };

  inputChange = async (e, type) => {
    e.persist();
    switch (type) {
      case "memberPin": {
        await this.setState({
          invalidMemberPin: false,
          memberPin: e.target.value,
        });
        break;
      }
      case "customerMobile": {
        if (e.target.value.length > 15) {
          toaster.warning("Invalid cell number");
        } else {
          await this.setState({
            invalidCustomerMobile: false,
            customerMobile: e.target.value,
          });
        }
        break;
      }
      case "customerName": {
        await this.setState({
          invalidCustomerName: false,
          customerName: e.target.value,
        });
        break;
      }
      case "customerEmail": {
        await this.setState({
          customerEmail: e.target.value,
        });
        break;
      }
      default: {
      }
    }
  };

  changeCountryCode = async (countryCode) => {
    this.setState({
      selectedCountryCode: countryCode,
    });
  };

  mobileInputOnBlur = async () => {
    const { customerMobile } = this.state;

    await this.setState({
      loader: true,
    });
    if (customerMobile) {
      if (validator.isMobilePhone(this.state.customerMobile.toString().trim())) {
        await this.props.dispatch(
          getCustomerDetails({
            mobile: customerMobile,
          })
        );
        if (this.props.customerData) {
          const { customerData } = this.props;

          if (customerData.data && customerData.data["isMember"]) {
            await this.setState({
              disableNameAndEmailEdit: true,
            });
          } else {
            await this.setState({
              disableNameAndEmailEdit: false,
            });
          }
          const customerDetails = customerData.data && customerData.data["customerDetails"];
          this.setState({
            customerName: customerDetails ? customerDetails.customerName : "",
            customerEmail: customerDetails ? customerDetails.customerEmail : "",
          });
        }
      } else {
        this.setState({
          invalidCustomerMobile: true,
        });
      }
    }

    await this.setState({
      loader: false,
    });
  };

  togglePaidStatus = async () => {
    const { paidStatus } = this.state;

    this.setState({
      isRedeemCredits: false,
      sendPaymentLink: false,
      paidStatus: !paidStatus,
    });
  };

  toggleCreditsRedeem = async () => {
    const { isRedeemCredits } = this.state;

    this.setState({
      isRedeemCredits: !isRedeemCredits,
      memberPin: "",
      sendPaymentLink: false,
    });
  };

  getPriceAndDiscount = async (courts, courtId) => {
    let price = 0;
    let selectedCourt = await courts.find((court) => court.courtId === parseInt(courtId));

    price = selectedCourt.price;
    let slotDiscount = {};

    slotDiscount = selectedCourt.slotDiscount;
    return { price, slotDiscount };
  };

  updateSelectedCourt = async (courtId, courts) => {
    const cart = getCartDetails();
    await this.setState({
      count: 1,
    });
    const selectedCourt = courts.find((court) => court.courtId === parseInt(courtId));
    await this.setState({
      maxBookable: selectedCourt.bookableCount,
    });
    await this.setState({
      selectedCourt,
    });

    await cart.slots.forEach(async (item) => {
      let { price, slotDiscount } = await this.getPriceAndDiscount(item.slot.courts, courtId);

      Object.assign(item.slot, {
        courtId: selectedCourt.courtId,
        courtName: selectedCourt.courtName,
        courtBrothers: selectedCourt.courtBrothers,
        price: price,
        slotDiscount: slotDiscount,
        activityType: this.state.activityType,
      });
    });

    await getCartSummaryAndPrice(cart);

    await this.props.dispatch(updateCartData(cart));
  };

  showEditAmountDialog = async (status) => {
    await this.setState({
      editAmountDialogIsShown: status,
    });
  };

  toggleSendPaymentLinkStatus = async () => {
    const { sendPaymentLink } = this.state;

    this.setState({
      isRedeemCredits: false,
      paidStatus: false,
      sendPaymentLink: !sendPaymentLink,
    });
  };

  toggleSendBookingConfirmationSMS = async () => {
    const { sendBookingConfirmationSMS } = this.state;

    this.setState({
      sendBookingConfirmationSMS: !sendBookingConfirmationSMS,
    });
  };

  validateBooking = () => {
    const { customerMobile, customerName, isRedeemCredits, memberPin, customerEmail } = this.state;
    let validation = true;

    if (!customerMobile) {
      validation = false;
      this.setState({
        invalidCustomerMobile: true,
      });
    }
    if (!customerName) {
      validation = false;
      this.setState({
        invalidCustomerName: true,
      });
    }
    if (isRedeemCredits && !memberPin) {
      validation = false;
      this.setState({
        invalidMemberPin: true,
      });
    }

    if (customerEmail) {
      if (!validator.isEmail(customerEmail)) {
        validation = false;
        this.setState({
          invalidEmail: true,
        });
      }
    }

    return validation;
  };

  getBookingData = () => {
    const { customerData, cart } = this.props;
    let { count } = this.state;
    const {
      paidStatus,
      isRedeemCredits,
      memberPin,
      customerName,
      selectedCountryCode,
      customerMobile,
      sendPaymentLink,
      sendBookingConfirmationSMS,
      customerEmail,
    } = this.state;

    const { isBulkBooking, bulkBookingData } = this.props.location.state;

    const customerDetails = customerData.data && customerData.data["customerDetails"];

    return {
      coupon: null,
      toBeRegistered: customerData.data && customerData.data["toBeRegistered"],
      memberId: customerData.data && customerData.data["isMember"] ? customerDetails.id : null,
      nonMemberId:
        customerData.data && customerData.data["isNonMember"] ? customerDetails.id : null,
      paymentMode: paidStatus ? "Cash" : "No Pay",
      bookingRemarks: "",
      totalPaidAmount: paidStatus ? cart.slotsNetPrice : 0,
      grossAmount: cart.slotsGrossPrice,
      clubDiscount: 0,
      credits:
        isRedeemCredits && customerData.data && customerData.data["isMember"]
          ? cart.slotsNetPrice < customerDetails.credits
            ? cart.slotsNetPrice
            : customerDetails.credits
          : 0,
      creditsData:
        isRedeemCredits && customerData.data && customerData.data["isMember"]
          ? {
              mobile: customerDetails.customerMobile,
              advance: 0,
              memberPin: memberPin,
              credits: customerDetails["credits"],
              expiry: customerDetails["creditsExpiry"] || "9999-12-31",
            }
          : {},
      slots: cart.slots,
      customerDetails: {
        name: customerName,
        countryCode: selectedCountryCode,
        mobile: customerMobile,
        email: customerEmail,
        additionalInfo: "",
        company: "",
      },
      isPatternBooking: isBulkBooking,
      patternBookingData: bulkBookingData || {},
      transactionData: {
        type: 1,
        mode: 0,
        handler: getCookie("username"),
        place: "Partner-App",
      },
      sendSMS: sendBookingConfirmationSMS,
      sendPaymentLink,
    };
  };

  bookingComplete = async () => {
    await this.back();
    this.props.dispatch(updateCartData(clearCart()));
  };

  handleBookingSuccess = async (cartSummary) => {
    const { selectedCourt, customerMobile, count, activityType } = this.state;

    const { isBulkBooking, bulkBookingData, bookingData } = this.props.location.state;

    await this.showConfirmationDialog({
      status: true,
      header: "Booking Confirmed",
      information: isBulkBooking ? (
        <Pane
          display={"flex"}
          justifyContent={"flex-start"}
          information
          flexDirection={"column"}
          paddingRight={20}
        >
          <Pane
            display={"flex"}
            flexBasis={"100%"}
            justifyContent={"space-between"}
            marginTop={10}
            marginBottom={10}
          >
            <Strong>{bulkBookingData["activityName"]}</Strong>
            <Text>{bulkBookingData["courtNames"].join(", ")}</Text>
          </Pane>
          <Pane display={"flex"} flexDirection={"column"} justifyContent={"center"}>
            <Strong size={100} marignRight={10}>
              Date & Time
            </Strong>
            <Text>
              {`${getFormattedDate(bulkBookingData["startDate"], "YYYY-MM-DD", "ddd, Do MMM YY")} -
                        ${getFormattedDate(
                          bulkBookingData["endDate"],
                          "YYYY-MM-DD",
                          "ddd, Do MMM YY"
                        )}`}
            </Text>
            <Text>
              {`${getFormattedTime(bulkBookingData["startTime"])} -
                        ${getFormattedTime(bulkBookingData["endTime"])}`}
            </Text>
            <Text>{bulkBookingData["dayNames"].join(", ")}</Text>
          </Pane>
        </Pane>
      ) : (
        <BookingConfirmationDialogContent
          selectedCourt={selectedCourt}
          cartSummary={cartSummary}
          customerMobile={customerMobile}
          count={count}
          activityType={activityType}
        />
      ),
      action: this.bookingComplete,
      closeAction: this.bookingComplete,
    });
  };

  handleBookingError = async () => {
    if (this.props.bookingData.message === "invalid member mobile or pin") {
      await this.setState({
        invalidMemberPin: true,
      });
    } else {
      this.props.history.push("/");
      toaster.warning(this.props.bookingData.message);
      this.props.dispatch(updateCartData(clearCart()));
      this.setState({
        ...this.baseState,
      });
      this.props.dispatch({ type: "SET_BOOKING_DATA", data: null });
    }
  };

  booking = async (cartSummary) => {
    await this.setState({
      loader: true,
    });
    if (this.validateBooking()) {
      await this.props.dispatch(confirmBooking(this.getBookingData()));
    }
    if (this.props.bookingData) {
      if (this.props.bookingData["requestStatus"] === 1) {
        await this.handleBookingSuccess(cartSummary);
      } else if (this.props.bookingData["requestStatus"] === -1) {
        await this.props.dispatch(updateCartData(clearCart()));
        this.setState({
          ...this.baseState,
        });
        await this.back();
      } else if (this.props.bookingData["requestStatus"] === 0) {
        toaster.warning(this.props.bookingData.message);
      } else {
        await this.handleBookingError();
      }
    }
    await this.setState({
      loader: false,
    });
  };

  showConfirmationDialog = async (data) => {
    await this.setState({
      confirmationDialog: {
        isShown: data["status"] || false,
        header: data["header"] || false,
        intent: data["intent"] || "none",
        confirmLabel: data["confirmLabel"] || "Ok",
        cancelLabel: data["cancelLabel"] || "",
        information: data["information"] || "",
        action: data["action"] || null,
        closeAction: data["closeAction"] || null,
      },
    });
  };

  cancel = async () => {
    await this.props.dispatch(updateCartData(clearCart()));
    await this.back();
  };

  handleIncrement = async () => {
    let { count, maxBookable, activityType } = this.state;
    let { cart } = this.props;

    if (count < maxBookable) {
      await this.setState({ count: count + 1 });
      await cart.slots.map((slot) => {
        slot.slot.count = count + 1;
      });
    } else {
      toaster.warning(`Only ${maxBookable} slots are available`);
    }
  };

  handleDecrement = async () => {
    let { count } = this.state;
    let { cart } = this.props;
    if (count > 1) {
      await this.setState({ count: count - 1 });
      cart.slots.map((slot) => {
        slot.slot.count = count > 1 ? count - 1 : 1;
      });
    }
  };

  render() {
    const {
      isRedeemCredits,
      selectedCountryCode,
      memberPin,
      customerMobile,
      customerName,
      customerEmail,
      paidStatus,
      selectedCourt,
      loader,
      confirmationDialog,
      invalidCustomerMobile,
      invalidCustomerName,
      invalidMemberPin,
      editAmountDialogIsShown,
      sendPaymentLink,
      sendBookingConfirmationSMS,
      disableNameAndEmailEdit,
      invalidEmail,
      activityType,
      count,
      maxBookable,
    } = this.state;

    const { cart, customerData, availabilityData } = this.props;

    const { isBulkBooking, bulkBookingData } = this.props.location.state;

    const cartSummary =
      (cart && cart.slots && cart.slots.length && getCartSummaryAndPrice(cart)) || null;

    return (
      <React.Fragment>
        <div className={"checkout-header-container"}>
          <BackBar back={this.back} title={"Checkout"} />
          {/* <Heading
            paddingTop={16}
            paddingBottom={16}
            paddingRight={20}
            paddingLeft={20}
            size={700}
            minWidth={68}
          >
            Checkout
          </Heading> */}
        </div>
        <div className={"checkout-form-container"}>
          {isBulkBooking ? (
            <Pane
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"space-between"}
              marginBottom={15}
              marginTop={20}
              background={"tint2"}
              borderRadius={5}
              padding={10}
            >
              <Pane
                display={"flex"}
                flexBasis={"100%"}
                justifyContent={"space-between"}
                marginTop={10}
                flexDirection={"column"}
                marginBottom={10}
              >
                <Strong>{bulkBookingData["activityName"]}</Strong>
                <Text>{bulkBookingData["courtNames"].join(", ")}</Text>
              </Pane>
              <Pane
                display={"flex"}
                flexBasis={"100%"}
                justifyContent={"space-between"}
                marginBottom={10}
              >
                <Pane display={"flex"} flexDirection={"column"} justifyContent={"center"}>
                  <Strong size={100} marignRight={10}>
                    Date & Time
                  </Strong>
                  <Text>
                    {`${getFormattedDate(
                      bulkBookingData["startDate"],
                      "YYYY-MM-DD",
                      "ddd, Do MMM YY"
                    )} -
                                            ${getFormattedDate(
                                              bulkBookingData["endDate"],
                                              "YYYY-MM-DD",
                                              "ddd, Do MMM YY"
                                            )}`}
                  </Text>
                  <Text>
                    {`${getFormattedTime(bulkBookingData["startTime"])} -
                                ${getFormattedTime(bulkBookingData["endTime"])}`}
                  </Text>
                  <Text>{bulkBookingData["dayNames"].join(", ")}</Text>
                </Pane>
              </Pane>
            </Pane>
          ) : (
            <React.Fragment>
              {cartSummary && (
                <Pane
                  display={"flex"}
                  flexBasis={"100%"}
                  justifyContent={"space-between"}
                  marginBottom={25}
                  background={"tint2"}
                  borderRadius={5}
                  padding={7}
                  marginTop={30}
                  maxHeight={71}
                >
                  <Pane
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"space-between"}
                    height={55}
                    flexBasis={"100%"}
                  >
                    <Strong>{cartSummary["activityName"]}</Strong>
                    <Pane display={"flex"} marginBottom={1} alignItems={"center"}>
                      <CalendarIcon paddingRight={5} />
                      <Text size={400}>{cartSummary["date"]}</Text>
                      <Text marginRight={10} marginLeft={10}>
                        |
                      </Text>
                      <TimeIcon paddingRight={5} />
                      <Text size={400}>{cartSummary["slots"]}</Text>
                    </Pane>
                  </Pane>
                </Pane>
              )}
            </React.Fragment>
          )}
          <Pane marginTop={10} marginBottom={invalidCustomerMobile ? 10 : 20} height={64}>
            <Strong fontWeight={500} height={20}>
              Mobile
            </Strong>
            {selectedCountryCode ? (
              <Pane
                marginTop={4}
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-start"}
              >
                <CountryCodeSelector
                  selectedCountryCode={selectedCountryCode}
                  changeCountryCode={this.changeCountryCode}
                />
                <TextInput
                  id='mobile-number'
                  isInvalid={invalidCustomerMobile}
                  width={"66%"}
                  className={"checkout-text-field"}
                  value={customerMobile}
                  onChange={(e) => this.inputChange(e, "customerMobile")}
                  type={"tel"}
                  onBlur={this.mobileInputOnBlur}
                />
              </Pane>
            ) : (
              <Loader type={1} top={true} bottom={true} />
            )}
            {invalidCustomerMobile && (
              <InlineAlert marginTop={5} intent='danger'>
                <Small color={"#bf0e08"} fontWeight={400}>
                  Enter a valid mobile number
                </Small>
              </InlineAlert>
            )}
          </Pane>
          <TextInputField
            marginTop={invalidCustomerMobile ? 30 : 0}
            isInvalid={invalidCustomerName}
            validationMessage={invalidCustomerName ? "Enter name" : null}
            label={"Name"}
            className={"checkout-text-field"}
            value={customerName}
            disabled={disableNameAndEmailEdit}
            onChange={(e) => this.inputChange(e, "customerName")}
          />
          <TextInputField
            label={"Email"}
            className={"checkout-text-field"}
            isInvalid={invalidEmail}
            marginTop={invalidEmail ? 10 : 0}
            validationMessage={invalidEmail ? "Please enter a valid email" : null}
            value={customerEmail}
            disabled={disableNameAndEmailEdit}
            onChange={(e) => this.inputChange(e, "customerEmail")}
          />
          <Pane display={"flex"} justifyContent={"space-between"} marginBottom={20}>
            <Pane
              display={"flex"}
              alignItems={"center"}
              justifyContent={"space-between"}
              height={40}
              width={"50%"}
              marginRight={10}
              padding={10}
              border={"default"}
              borderRadius={5}
              borderColor={"#425A70"}
            >
              <Strong onClick={this.togglePaidStatus} fontWeight={500} width={"25%"}>
                Paid
              </Strong>
              <Switch onChange={this.togglePaidStatus} width={"25%"} checked={paidStatus} />
            </Pane>
            {!isBulkBooking && (
              <Pane
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                height={40}
                width={"50%"}
                marginLeft={10}
                border={"2px solid"}
                borderRadius={5}
                borderColor={"#425A70"}
              >
                <CourtSelector
                  selectedCourt={selectedCourt}
                  updateSelectedCourt={this.updateSelectedCourt}
                />
              </Pane>
            )}
          </Pane>
          {activityType === 1 && (
            <Pane display={"flex"} justifyContent={"flex-end"} paddingRight={10}>
              <Text color={"green"} size={300}>{`Max Bookable slot(s)(${maxBookable})`}</Text>
            </Pane>
          )}
          {activityType === 1 && (
            <Pane display={"flex"} justifyContent={"space-between"} marginBottom={10} padding={10}>
              <Pane
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                height={40}
                width={"60%"}
                marginRight={10}
              >
                <Strong>Slots Count</Strong>
              </Pane>
              {
                <Pane
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  height={40}
                  width={"40%"}
                  marginLeft={10}
                  border={"2px solid"}
                >
                  {" "}
                  <Button intent='none' paddingRight={3} height={20} paddingLeft={3}>
                    {" "}
                    <MinusIcon onClick={this.handleDecrement} />
                  </Button>
                  <Strong>{count}</Strong>
                  <Button intent='none' paddingRight={3} height={20} paddingLeft={3}>
                    <PlusIcon onClick={this.handleIncrement} />
                  </Button>
                </Pane>
              }
            </Pane>
          )}
          <Menu.Divider />
          {customerMobile &&
          customerData &&
          customerData.data &&
          customerData.data["isMember"] &&
          customerData.data["customerDetails"].credits ? (
            <React.Fragment>
              <Pane
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                background={"tint2"}
                borderRadius={5}
                paddingLeft={10}
                paddingRight={10}
                height={40}
                marginBottom={10}
              >
                <Strong>
                  {`Redeem Credits:
                                ${parseFloat(customerData.data["customerDetails"].credits).toFixed(
                                  2
                                )}`}
                </Strong>
                <Switch
                  disabled={paidStatus}
                  checked={isRedeemCredits}
                  size={20}
                  onChange={this.toggleCreditsRedeem}
                />
              </Pane>
              {isRedeemCredits && (
                <div id={"member-pin-input"} className={"member-pin-input-container"}>
                  <TextInputField
                    isInvalid={invalidMemberPin}
                    validationMessage={invalidMemberPin ? "Invalid Pin" : null}
                    label={"Member Pin"}
                    className={"checkout-text-field"}
                    marginBottom={10}
                    value={memberPin}
                    type={"password"}
                    onChange={(e) => this.inputChange(e, "memberPin")}
                    onFocus={() => {
                      const element = document.getElementById("member-pin-input");
                      const pinInput = element.querySelector("input");
                      if (element) {
                        pinInput.setAttribute("password", "new-password");
                        pinInput.setAttribute("inputmode", "numeric");
                        element.scrollIntoView({
                          behavior: "smooth",
                        });
                      }
                    }}
                  />
                </div>
              )}
            </React.Fragment>
          ) : (
            <React.Fragment />
          )}

          {cartSummary && (
            <Pane
              display={"flex"}
              alignItems={"flex-start"}
              justifyContent={"space-between"}
              paddingLeft={10}
              paddingRight={10}
              height={40}
              marginTop={20}
              marginBottom={20}
            >
              <Strong>Total Amount</Strong>
              <Pane
                display={"flex"}
                flexDirection={"column"}
                alignItems={"flex-end"}
                justifyContent={"space-between"}
              >
                <Strong>{`${getCurrency()} ${cart.cartPrice * count}`}</Strong>
                <Button
                  appearance={"minimal"}
                  paddingRight={0}
                  paddingLeft={0}
                  onClick={() => this.showEditAmountDialog(true)}
                >
                  Edit Amount
                </Button>
              </Pane>
            </Pane>
          )}
          <Pane display={"flex"} justifyContent={"flex-end"} marginBottom={20}>
            {/* {cart && cart.showPaymentLink && (
              <Pane
                display={'flex'}
                alignItems={'center'}
                justifyContent={'space-between'}
                border={'default'}
                borderRadius={5}
                padding={10}
              >
                <Strong>Payment Link</Strong>
                <Switch
                  marginLeft={10}
                  disabled={paidStatus}
                  checked={sendPaymentLink}
                  onChange={this.toggleSendPaymentLinkStatus}
                />
              </Pane>
            )} */}
            {!isBulkBooking && (
              <Pane
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                border={"default"}
                width={"100%"}
                borderRadius={5}
                padding={10}
                marginX={majorScale(1)}
              >
                <Strong onClick={this.toggleSendBookingConfirmationSMS} width={"85%"}>
                  Send Confirmation SMS/Email
                </Strong>
                <Switch
                  width={"15%"}
                  marginLeft={5}
                  checked={sendBookingConfirmationSMS}
                  onChange={this.toggleSendBookingConfirmationSMS}
                />
              </Pane>
            )}
          </Pane>
          <Pane display={"flex"} justifyContent={"flex-end"} marginBottom={20}>
            {!isBulkBooking && (
              <Pane
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                border={"default"}
                width={"100%"}
                borderRadius={5}
                padding={10}
                marginX={majorScale(1)}
              >
                <Strong onClick={this.toggleSendPaymentLinkStatus} width={"85%"}>
                  Send Payment Link
                </Strong>
                <Switch
                  width={"15%"}
                  marginLeft={5}
                  checked={sendPaymentLink}
                  onChange={this.toggleSendPaymentLinkStatus}
                />
              </Pane>
            )}
          </Pane>
        </div>
        <div className={"checkout-action-container"}>
          <Button
            marginRight={5}
            height={36}
            onClick={() =>
              this.showConfirmationDialog({
                status: true,
                intent: "danger",
                confirmLabel: "Yes",
                cancelLabel: "No",
                information: "Are you sure you want to cancel",
                action: this.cancel,
              })
            }
          >
            Cancel
          </Button>
          <Button
            appearance={"primary"}
            marginLeft={5}
            marginRight={30}
            height={36}
            onClick={() => this.booking(cartSummary)}
          >
            Confirm
          </Button>
        </div>
        {loader && <Loader type={1} />}
        <ConfirmationDialog
          showDialog={this.showConfirmationDialog}
          isShown={confirmationDialog.isShown}
          header={confirmationDialog.header}
          confirmLabel={confirmationDialog.confirmLabel}
          cancelLabel={confirmationDialog.cancelLabel}
          intent={confirmationDialog.intent}
          information={confirmationDialog.information}
          action={confirmationDialog.action}
          closeAction={confirmationDialog.closeAction}
        />
        <EditAmountDialog
          isShown={editAmountDialogIsShown}
          showDialog={this.showEditAmountDialog}
          source={"checkout"}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ cart, countryCodes, customerData, bookingData, availabilityData }) => ({
  cart,
  countryCodes,
  customerData,
  bookingData,
  availabilityData,
});

export default connect(mapStateToProps)(Checkout);
